import { render, staticRenderFns } from "./CalculationForm.vue?vue&type=template&id=6aaa3060&"
import script from "./CalculationForm.vue?vue&type=script&lang=js&"
export * from "./CalculationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports